import React from "react";
import "./OurApproach.scss";

const APPROACH_HEADINGS = {
  "Business Transformation": "Performance Optimization & Growth Strategy",
  "Business Diagnostic": "Business Health Check",
  "IPO Project Management": "IPO Readiness & Execution",
  "Management Consulting": "Strategic Business Advisory",
  "CFO Services": "On-Demand Financial Strategy & Control",
  "Detailed Project Report & Research Report": "Project Feasibility & Risk Assessment",
  "Startup Advisory": "Growth Strategy",
  "Fund Advisory": "Capital Deployment & Fund Strategy",
  "Transaction Advisory": "M&A and Strategic Transaction Support",
  "Human Capital": "People Strategy & Organizational Growth"
};

const OurApproach = ({ data, hasSubServices, serviceTitle }) => {
  if (!data || data.length === 0) return null;

  const heading = APPROACH_HEADINGS[serviceTitle] || "End-to-End Performance Diagnostic";

  return (
    <section className="our-approach-section">
      <span className="subtitle">Our Approach</span>
      <h2 className="title">{heading}</h2>

      <div
        className={`approach-grid ${data.length > 4 ? "has-many-items" : ""}`}
      >
        {data.map((step, index) => (
          <div key={index} className="approach-card">
            <div className="icon-wrapper">
              <div className="icon-circle">
                {step.icon ? (
                  <img src={step.icon} alt={`Approach step ${index + 1}`} />
                ) : (
                  <div className="icon-placeholder"></div>
                )}
              </div>
            </div>
            <p className="description">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurApproach;
